module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/be-914a3c37d1998aa1f6b0bcb231f5f98f.svg";